import { Injectable } from "@angular/core";
import { SpectrumUserService } from "./spectrum-user.service";
import { LogService } from "./log.services";
import { Observable, ReplaySubject, of } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private spectrumID: string = "";
  
  private loadingSpectrumUser: boolean = false;
  private spectrumUserSource = new ReplaySubject<string>(1);
  spectrumUserComplete = this.spectrumUserSource.asObservable();

  constructor(private spectrumUserService: SpectrumUserService, private logService: LogService) {
  }

  public CreateOrUpdateSpectrumUser() {
    this.GetSpectrumID().subscribe(_ => {
      if (this.spectrumID == "") {
        this.spectrumUserService.CreateSpectrumUser().subscribe(
          (data: any) => {
            this.spectrumID = data;
            sessionStorage.setItem("SpectrumUserId", this.spectrumID);
          },
          (error) => {
            this.logService.error("Could not create Spectrum user for member");
          }
        )
      }
      else {
        this.spectrumUserService.UpdateSpectrumUser().subscribe(
          (data: any) => {
            this.spectrumID = data;
          },
          (error) => {
            this.logService.error("Could not update Spectrum user");
          }
        )
      }
    })    
  }

  public GetSpectrumID(): Observable<string> {
    var sessionSpectrumId = sessionStorage.getItem("SpectrumUserId");
    if (sessionSpectrumId != undefined && sessionSpectrumId.length > 0) {
      return of(sessionSpectrumId);
    }
    else {
      if(this.loadingSpectrumUser)
        return this.spectrumUserComplete;

      this.loadingSpectrumUser = true;
      this.spectrumUserService.GetSpectrumUserId().subscribe(
        (spectrumId: string) => {
          this.spectrumID = spectrumId;
          sessionStorage.setItem("SpectrumUserId", spectrumId);
          this.spectrumUserSource.next(spectrumId);
        },
        (error) => {
          this.logService.error("Could not retrieve Spectrum user");
          this.spectrumUserSource.next("");
        }
      );
      return this.spectrumUserComplete;
    }
  }  
}
